import { render, staticRenderFns } from "./WithLabel.vue?vue&type=template&id=389e2541"
import script from "./WithLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./WithLabel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports